// Admin › Features: every workspace's feature switches in one read
// (GET /api/admin/features, admin only; services/admin_features.py). Read
// only: each switch saves through the route that owns it
// (features/admin/features/useFeatureToggle.ts), then this is refetched.

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { components } from "@/types/api.gen";

export type AdminFeaturesView = components["schemas"]["AdminFeatures"];

export const adminFeaturesKey = ["admin-features"] as const;

export function useAdminFeatures() {
  return useQuery({
    queryKey: adminFeaturesKey,
    queryFn: ({ signal }) => apiFetch<AdminFeaturesView>("/api/admin/features", { signal }),
    staleTime: 15_000,
  });
}
